import flatpickr from 'flatpickr';
import { Danish } from 'flatpickr/dist/l10n/da';
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.dk';

export function initPhone(selector: string): void {
    document.querySelectorAll(selector).forEach((el: HTMLElement) => {
        new Cleave(el, {
            phone: true,
            phoneRegionCode: 'DK',
        });
    });
}

export function initCpr(selector: string): void {
    new Cleave(selector, {
        numericOnly: true,
        delimiter: '-',
        blocks: [6, 4],
    });
}

export function initDatePicker(
    selector: string,
    onChange: (selectedDates: Date[]) => void,
): void {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const datePicker = flatpickr(selector, {
        locale: Danish,
        allowInput: true,
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'd.m.Y',
        minDate: today,
        onReady: function () {
            new Cleave(this.altInput, {
                date: true,
                delimiter: '.',
                datePattern: ['d', 'm', 'Y'],
            });
        },
        onChange: onChange,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any;
    datePicker.setDate(now);
    // make sure value is set when tabbing out of the field
    datePicker._input.addEventListener(
        'blur',
        () => {
            const value = datePicker._input.value;
            datePicker.setDate(value, true, 'd.m.Y');
        },
        true,
    );
}

export function initTimePicker(
    selector: string,
    onChange: (selectedDates: Date[]) => void,
): void {
    const startTimePicker = flatpickr(selector, {
        locale: Danish,
        allowInput: true,
        altInput: true,
        altFormat: 'H:i',
        dateFormat: 'H:i',
        enableTime: true,
        noCalendar: true,
        clickOpens: false,
        time_24hr: true,
        onReady: function () {
            new Cleave(this.altInput, {
                time: true,
                timePattern: ['h', 'm'],
            });
        },
        onChange: onChange,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }) as any;
    startTimePicker.setDate(new Date());
    // make sure value is set when tabbing out of the field
    startTimePicker._input.addEventListener(
        'blur',
        () => {
            const value = startTimePicker._input.value;
            startTimePicker.setDate(value, true, 'H:i');
        },
        true,
    );
}
